<script>
        import * as animateScroll from "svelte-scrollto";
        import { onMount } from 'svelte';
        import Icon from 'fa-svelte';
        import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
        import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
        import CVSTable from '../table.svelte';
        export let selectedPost;
        export let subSelection;
    
        onMount(async () => {
/*             if(selectedPost === undefined) console.log(window.location.hash.split("/")[2]);  */

            if (selectedPost == null) {
                const proxyurl = "";
                const url = 'https://plataforma.cvschile.cl/site/new/' + window.location.hash.split('/')[2];

                try {
                    const response = await fetch(proxyurl + url);
                    selectedPost = await response.json();

                    let unix_timestamp = selectedPost.published_at;

                    var date = new Date(unix_timestamp * 1000);

                    selectedPost.published_at = date.toLocaleString();

                    console.log(selectedPost);
                } catch (error) {
                    console.log(error);
                }
            }

            if(subSelection == 0)  animateScroll.scrollToTop();
            else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
        });
        
        

</script>

<div class="row">

    <div class="col-12 white-bg" style="overflow:hidden;min-height: 100vh;">
        <img src="./img/background-A.svg" alt="" class="background-right disabe-img" style="height: 100vh;">
        <div class="row">
            {#if selectedPost}
                <div class="text-left col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix post-info-title">
                    <h2 class="title-content" style="margin: 20px 0 0 0; text-align: left; text-align-last: left;">
                        <a href="/#/news">&#60;</a>
                        {selectedPost.title}
                    </h2>
                    <hr class="underline-content">
                </div>
                <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                    <div class="text-content">
                        <span class="post-info-published-at">Fecha de publicación: {selectedPost.published_at}</span>
                        <br><br>
                        {@html selectedPost.body}
                    </div>
                </div>
            {:else}
                <div class="d-flex justify-content-center" style="margin-top:25%; margin-left: 47%;">
                    <div class="spinner-border" role="status" style="height: 100px;width: 100px;">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>

.text-content :global(img){
    max-width: 100%;
}

.post-info-published-at{
    float: right;
    opacity: 0.8;
    font-size: 15pt;
}

.post-info-title{
    text-align-last: center; 
    text-align: -webkit-center;
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    /* max-height: 100vh; */
}

@media (max-width: 1400px){
    .disabe-img {
        display:none;
    }
    .padding-fix{
        padding:0 15px;
    }
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    max-height: 100vh;
}

.padding-fix{
    padding:0 8px;
}

@media (max-width: 1400px){
    .disabe-img {
        display:none;
    }
    .padding-fix{
        padding:0 15px;
    }
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

</style>
